class PaginationView {
	_parentEl = document.querySelector('.pagination')

	addHandlerClick(handler) {
		this._parentEl.addEventListener('click', e => {
			const btn = e.target.closest('.btn--inline')
			if (!btn) return

			const goToPage = +btn.dataset.goto
			handler(goToPage)
		})
	}

	_generateMarkup(state) {
		const curPage = state.pagination.page
		const dataSource = state.filteredAddreses.length === 0 ? state.addresses : state.filteredAddreses
		const numPages = Math.ceil(dataSource.length / state.pagination.resultPerPage)

		// Page 1 and there are other pages
		if (curPage === 1 && numPages > 1) {
			return `
				<button data-goto="${curPage + 1}" class="btn--inline pagination__btn--next">
					<span>Page ${curPage + 1}</span>
					<i class="fa-solid fa-arrow-right"></i>
				</button>
			`
		}

		// Last page
		if (curPage === numPages && numPages > 1) {
			return `
				<button data-goto="${curPage - 1}" class="btn--inline pagination__btn--prev">
					<i class="fa-solid fa-arrow-left"></i>
					<span>Page ${curPage - 1}</span>
				</button>
			`
		}

		// Other pages (between first and last)
		if (curPage > 1 && curPage < numPages) {
			return `
				<button data-goto="${curPage - 1}" class="btn--inline pagination__btn--prev">
					<i class="fa-solid fa-arrow-left"></i>
					<span>Page ${curPage - 1}</span>
				</button>
				<button data-goto="${curPage + 1}" class="btn--inline pagination__btn--next">
					<span>Page ${curPage + 1}</span>
					<i class="fa-solid fa-arrow-right"></i>
				</button>
			`
		}

		// Page 1 and there are no other pages
		return ''
	}

	renderPaginationButtons(state) {
		this._parentEl.innerHTML = ''
		const html = this._generateMarkup(state)
		this._parentEl.insertAdjacentHTML('afterbegin', html)
	}
}

export default new PaginationView()
